/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles.scss'
import React from 'react'
import { AdminModeProvider } from './src/context/AdminModeContext'

export const wrapRootElement = ({ element }) => (
  <AdminModeProvider>{element}</AdminModeProvider>
)
